import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import { Box, Typography, Button } from "@material-ui/core";
import { Logo } from "Assets/images";
import Modal from "Components/modal/Modal";
import useStyles from "./styles";

const WelcomeNote = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const showModal = get(history, "location.state.showModal", false);
  const [openModal, setOpenModal] = useState(showModal);

  return (
    <Modal
      open={openModal}
      body={
        <Box
          className={classes.banner}
          borderRadius="borderRadius"
          width="100%"
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <img src={Logo} alt="iAlign logo" />
          <Typography variant="subtitle1">Welcome to iAlign.Work</Typography>
          <Button
            variant="contained"
            color="primary"
            data-testid="btn"
            onClick={() => {
              setOpenModal(false);
              history.replace("", null); // this is used to clear history
            }}
          >
            {t("onboarding.welcomeNote.letsStart")}
          </Button>
        </Box>
      }
    />
  );
};

export default WelcomeNote;
